// TODO: workaround; backend should return data already in Portuguese
export const classesInPortuguese = {
  foreignMatterImpuritiesPercentage: 'Mat. Estranhas/Impurezas',
  brokenSplitCrushedPercentage: 'Partidos/Quebrados/Amassados',
  greenPercentage: 'Esverdeado',
  burntPercentage: 'Queimados',
  burntScorchedPercentage: 'Queimados/Ardidos',
  moldyPercentage: 'Mofados',
  fermentedPercentage: 'Fermentados',
  germinatedPercentage: 'Germinados',
  damagedChoppedPercentage: 'Danificados/Picados',
  immaturePercentage: 'Imaturos',
  shriveledPercentage: 'Chochos'
}

export const ALL_CLASSES = 'Todas'

/** Limites máximos do Padrão Básico (%). Acima do limite = fora do padrão. */
export const BASIC_STANDARD_LIMITS = {
  [classesInPortuguese.foreignMatterImpuritiesPercentage]: 1.0,
  [classesInPortuguese.brokenSplitCrushedPercentage]: 30.0,
  [classesInPortuguese.greenPercentage]: 8.0,
  [classesInPortuguese.burntPercentage]: 1.0,
  [classesInPortuguese.burntScorchedPercentage]: 4.0,
  [classesInPortuguese.moldyPercentage]: 6.0,
  'Avariados – total': 8.0
}

export function getBasicStandardLimit (classLabel) {
  if (!classLabel) return null
  const limit = BASIC_STANDARD_LIMITS[classLabel]
  return typeof limit === 'number' ? limit : null
}

export function parsePercentValue (value) {
  const num = parseFloat(String(value).replace('%', '').replace(',', '.'))
  return Number.isFinite(num) ? num : null
}

/** @returns {'none'|'within'|'outside'} */
export function getStandardCompliance (value, classLabel) {
  const num = parsePercentValue(value)
  const limit = getBasicStandardLimit(classLabel)
  if (num == null || limit == null) return 'none'
  return num > limit ? 'outside' : 'within'
}

export const EXCLUDED_CHART_CLASSES = ['foreignMatterImpuritiesPercentage']

export const CHART_TYPE_OPTIONS = [
  { value: 'bar', label: 'Barras', icon: 'fas fa-chart-bar' },
  { value: 'boxPlot', label: 'Box-plot', icon: 'fas fa-chart-area' },
  { value: 'pie', label: 'Pizza', icon: 'fas fa-chart-pie' }
]

const monthNames = {
  1: 'Jan',
  2: 'Fev',
  3: 'Mar',
  4: 'Abr',
  5: 'Mai',
  6: 'Jun',
  7: 'Jul',
  8: 'Ago',
  9: 'Set',
  10: 'Out',
  11: 'Nov',
  12: 'Dez'
}

export function resolveClassStatKey (name) {
  if (!/percentage/i.test(name)) return null
  if (classesInPortuguese[name]) return name
  return Object.keys(classesInPortuguese).find(
    key => key.toLowerCase() === String(name).toLowerCase()
  ) || null
}

export function getPeriodSortKey (column) {
  const parts = String(column).split('-').map(Number)
  if (parts.length === 3) {
    if (parts[0] > 31) {
      const [year, month, day] = parts
      return (year * 10000) + (month * 100) + day
    }
    const [day, month, year] = parts
    return (year * 10000) + (month * 100) + day
  }
  if (parts.length === 2) {
    const [first, year] = parts
    return (year * 100) + first
  }
  return 0
}

export function formatPeriodLabel (column, groupBy = 'month') {
  const parts = String(column).split('-').map(Number)
  if (parts.length === 3) {
    if (parts[0] > 31) {
      const [, month, day] = parts
      return `${day} ${monthNames[month] || month}`
    }
    const [day, month] = parts
    return `${day} ${monthNames[month] || month}`
  }
  if (parts.length === 2) {
    const [first] = parts
    if (groupBy === 'week') {
      return `Semana ${first}`
    }
    return monthNames[first] || column
  }
  return column
}

export function getApiGroupBy (dateRangeStart, dateRangeEnd) {
  if (!dateRangeStart || !dateRangeEnd) return 'month'
  const start = new Date(dateRangeStart)
  const end = new Date(dateRangeEnd)
  const days = Math.floor((end - start) / (1000 * 60 * 60 * 24)) + 1
  if (days <= 31) return 'day'
  if (days <= 92) return 'week'
  return 'month'
}

export function getSelectedClassKeys (chartClasses, selectedClasses) {
  const allKeys = chartClasses
    .filter(name => resolveClassStatKey(name))
    .filter(name => !EXCLUDED_CHART_CLASSES.includes(name))

  if (!selectedClasses || selectedClasses.length === 0 || selectedClasses.includes(ALL_CLASSES)) {
    return allKeys
  }

  return allKeys.filter(name => selectedClasses.includes(classesInPortuguese[name]))
}

export function buildClassFilterOptions (classKeys) {
  const options = classKeys
    .filter(name => !EXCLUDED_CHART_CLASSES.includes(name))
    .map(name => classesInPortuguese[name])
    .filter(Boolean)
    .sort((a, b) => a.localeCompare(b, 'pt-BR'))

  options.unshift(ALL_CLASSES)
  return options
}
